export class Telefono {
  IdNumeroTelefonico: string;
  IdDatosPersona: string;
  IdCatTipoNumeroTelefonico: string;
  Numero: string;
  Extension: string;
  FechaRegistro: string;
  Activo = true;
}
